import { Operation } from '@custom/schema';
import React from 'react';
export var withOperation = function(id, Component) {
    var wrapper = function(props) {
        return /*#__PURE__*/ React.createElement(Operation, {
            id: id,
            variables: props
        }, function(result) {
            if (result.state === 'success') {
                return /*#__PURE__*/ React.createElement(Component, result.data);
            }
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        });
    };
    wrapper.displayName = "withOperation(".concat(id, ")");
    return wrapper;
};
